module.exports = __webpack_public_path__ + "img/mor-read_04.6f3aa4a5.jpg";